export const GET_COUPON_ACTIVITIES = "GET_COUPON_ACTIVITIES";
export const GET_COUPON_ACTIVITY_BY_ID = "GET_COUPON_ACTIVITY_BY_ID";
export const UPDATE_COUPON_ACTIVITY = "UPDATE_COUPON_ACTIVITY";
export const DELETE_COUPON_ACTIVITY = "DELETE_COUPON_ACTIVITY";
export const CREATE_COUPON_ACTIVITY = "CREATE_COUPON_ACTIVITY";
